export default class ClassStatusVM {
    constructor() {

    }

    public classId: number;
    public studentId: number;
    public statusId: number;
}
